import React, { useEffect } from 'react'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { get } from 'libraries/lodash'
import url from 'libraries/front-end-core/core/url'
import { LEGISLATION } from 'constants/controllers'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import FlavourIcon from 'components/shared/FlavourIcon'
import Error from 'components/shared/Error'
import Item from 'components/legislation-reference/Item'

const LegislationReferences = ({ references, setHighlighted }) => {
  useEffect(() => {
    const highlightedList = []
    references.forEach(({ highlighted }) => {
      if (highlighted.length) {
        highlightedList.push(...highlighted)
      }
    })
    setHighlighted(highlightedList)
    return () => setHighlighted([])
  }, [references, setHighlighted])

  if (references.length === 0) {
    return <Error title='No data received' />
  }

  return (
    <section>
      <div className='content-view' style={{ fontSize: '10px' }}>
        {references.map(
          reference => (
            <Item key={reference.root} {...{ ...reference }} />
          )
        )}
        <div className='tc pv8 f6'>
          &copy;Crown copyright {new Date().getFullYear()}
        </div>
      </div>
    </section>
  )
}

const LegislationReferenceComponent = ({ pageToggleRight, setHighlighted, references, aol }) => {
  const title = get(references, '[0].context[0].title')
  const path = get(references, '[0].context[0].id')
  const linkable = get(references, '[0].linkable')
  const isArchived = get(references, '[0].isArchived', false)
  const handleOnClose = () => pageToggleRight(false)

  const titleElement = linkable
    ? (
      <a
        href={url(LEGISLATION, { aol, path })}
        data-event-category='Legislation Reference'
        data-event-action='Header link'
        data-event-label={title}
        className='black no-underline hover-underline f3 pr6 fw6'
      >
        {title}
      </a>
      )
    : title

  return (
    <div>
      <section className='flex justify-between items-center bb b--grey pt7 pb6 sticky top0 bg-page-background z5'>
        <div className='flex items-center justify-between w-100'>
          {titleElement}
          {isArchived && (
            <div className='flex justify-center items-center ba br2 b--dark-cerulean ph2'>
              <FlavourIcon flavour='archive' />
              <span className='ml2'>
                Archived
              </span>
            </div>
          )}
        </div>
        <IconButton
          onClick={handleOnClose}
          className='pointer black hover-cadet-blue'
          size='small'
          data-event-category='Legislation Reference'
          data-event-action='Close'
        >
          <CloseIcon />
        </IconButton>
      </section>
      <ResponseConsumer
        response={references}
        content={() => <LegislationReferences {...{ references, setHighlighted }} />}
      />
    </div>
  )
}

export default LegislationReferenceComponent
